import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "min-h-screen flex items-center justify-center px-4" }
const _hoisted_2 = { class: "flex flex-col items-center gap-4 rounded-lg shadow-lg border border-gray-300 p-4 text-center w-full" }
const _hoisted_3 = { class: "text-left" }
const _hoisted_4 = { class: "text-left" }
const _hoisted_5 = { class: "flex items-center gap-1" }
const _hoisted_6 = ["type"]
const _hoisted_7 = {
  key: 0,
  class: "text-red-500 text-sm mt-2"
}

import { ref, onMounted } from "vue";
import { signIn, confirmSignIn } from "aws-amplify/auth";
import { getCookie, deleteCookie, setCookie } from "../utils/cookies";
import { useGeneralStore } from "../stores/general";
import GenericButton from "./ui/GenericButton.vue";
import { scrollToInput } from "../utils/common";


export default /*@__PURE__*/_defineComponent({
  ...{ name: "LoginPage" },
  __name: 'LoginPage',
  emits: ["change-view"],
  setup(__props, { emit: __emit }) {


const general = useGeneralStore();
const emits = __emit;

const loading = ref(false);
const showPassword = ref(false);
const username = ref("");
const password = ref("");
const errorMessage = ref("");

const sigInEmailAndPassword = async () => {
  loading.value = true;
  errorMessage.value = "";
  try {
    const signInParams = { username: username.value, password: password.value };
    const { isSignedIn, nextStep } = await signIn(signInParams);
    if (
      !isSignedIn &&
      nextStep.signInStep == "CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED"
    ) {
      await confirmSignIn({ challengeResponse: password.value });
    }
    await general.generateFingerprint(() => {
      hasValidKey();
    });
  } catch (error: any) {
    console.error(error);
    errorMessage.value = "Correo o contraseña incorrectos";
    loading.value = false;
  }
};

function hasValidKey() {
  const currentKey = getCookie("booth");
  if (!currentKey) {
    emits("change-view", "setBoothKey");
  } else {
    const booth = getCookie("booth") as string;
    const days = general.getBooth.customConfig?.duracionSesion;
    setCookie("booth", booth, days);
    const fingerprint = getCookie("fingerprint") as string;
    general.getSession().then((session: any) => {
      const accessToken = session.tokens?.accessToken as object;
      if (!booth) {
        emits("change-view", "setBoothKey");
        return;
      }
      if (!fingerprint) {
        general.generateFingerprint(() => {
          hasValidKey();
        });
        return;
      }
      setCookie("fingerprint", fingerprint, days);
      general
        .postMedicalBoothsValidation({
          claveCabina: booth,
          fingerprint: fingerprint,
          accessToken: accessToken,
        })
        .then((res: any) => {
          if (res.code === 200) {
            general.setBooth(res.data);
            emits("change-view", "baseInformation");
          } else {
            const { idSesion } = res.message;
            if (idSesion) {
              general.deleteBoothSession(idSesion);
            }
            deleteCookie("booth");
            deleteCookie("fingerprint");
            emits("change-view", "setBoothKey");
          }
        });
    });
  }
  loading.value = false;
}

async function handleClick() {
  if (!document || !document.exitFullscreen) {
    errorMessage.value = "No se puede salir de pantalla completa...";
    return;
  }
  await document.exitFullscreen();
}

onMounted(() => {
  loading.value = true;
  general
    .getSession()
    .then((res) => (res.userSub ? hasValidKey() : (loading.value = false)));
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(GenericButton, {
      variant: "ghost",
      onClick: handleClick,
      class: "absolute top-0 right-3 text-primary-500"
    }, {
      default: _withCtx(() => _cache[5] || (_cache[5] = [
        _createTextVNode(" Salir ")
      ])),
      _: 1,
      __: [5]
    }),
    _createElementVNode("div", _hoisted_2, [
      _cache[9] || (_cache[9] = _createElementVNode("h1", { class: "text-2xl font-bold text-primary-900" }, "Iniciar Sesión", -1)),
      _cache[10] || (_cache[10] = _createElementVNode("hr", { class: "my-4 border-gray-200 w-full" }, null, -1)),
      _createElementVNode("form", {
        class: "flex flex-col gap-4",
        onSubmit: _withModifiers(sigInEmailAndPassword, ["prevent"])
      }, [
        _createElementVNode("div", _hoisted_3, [
          _cache[6] || (_cache[6] = _createElementVNode("label", {
            for: "email",
            class: "block text-sm font-medium text-primary-900"
          }, "Correo Electrónico", -1)),
          _withDirectives(_createElementVNode("input", {
            onFocus: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(scrollToInput) && _unref(scrollToInput)(...args))),
            type: "email",
            id: "email",
            name: "email",
            class: "w-full border border-gray-300 rounded p-2",
            placeholder: "correo@ejemplo.com",
            required: "",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((username).value = $event))
          }, null, 544), [
            [_vModelText, username.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _cache[7] || (_cache[7] = _createElementVNode("label", {
            for: "password",
            class: "block text-sm font-medium text-primary-900"
          }, "Contraseña", -1)),
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              onFocus: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(scrollToInput) && _unref(scrollToInput)(...args))),
              type: showPassword.value ? 'text' : 'password',
              id: "password",
              name: "password",
              class: "w-full border border-gray-300 rounded p-2",
              placeholder: "********",
              required: "",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((password).value = $event))
            }, null, 40, _hoisted_6), [
              [_vModelDynamic, password.value]
            ]),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (showPassword.value = !showPassword.value)),
              class: "text-primary-900 cursor-pointer"
            }, _toDisplayString(showPassword.value ? "Ocultar" : "Mostrar"), 1)
          ])
        ]),
        _createVNode(GenericButton, {
          variant: "primary",
          type: "submit",
          disabled: loading.value,
          loading: loading.value,
          class: "bg-gradient-to-r from-primary-400 to-primary-900 text-white p-4 rounded-full mt-4"
        }, {
          default: _withCtx(() => _cache[8] || (_cache[8] = [
            _createTextVNode(" Iniciar Sesión ")
          ])),
          _: 1,
          __: [8]
        }, 8, ["disabled", "loading"])
      ], 32),
      (errorMessage.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(errorMessage.value), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})